import React from 'react';
import PropTypes from 'prop-types';
import AudioContainer from '../../../common/audio/audioContainer';
import CountdownView from '../../../common/countdown/countdownView';
import { setArPageTitle } from '../../troUtils';

export default class TRCCountdownView extends React.Component {
    constructor(props) {
        super(props);
        setArPageTitle(props.isExternalURLSourcePresent, 'Countdown');
    }

    componentDidMount() {
        this.props.narrateScreen(this.props.isExternalURLSourcePresent, this.props.arLanguage);
    }

    componentWillUnmount() {
        this.props.cleanup();
    }

    render() {
        const { countdownTitle, onEndCounting, cleanup, isAvatarInitialized, isPaused } = this.props;

        return (
            <div>
                <CountdownView countdownTitle={countdownTitle} onEndCounting={onEndCounting} cleanup={cleanup} isAvatarInitialized={isAvatarInitialized} initialCount={this.props.isExternalURLSourcePresent ? 5 : 3} isPaused={isPaused} />
                <AudioContainer />
            </div>
        );
    }
}

TRCCountdownView.propTypes = {
    cleanup: PropTypes.func,
    narrateScreen: PropTypes.func,
    countdownTitle: PropTypes.node,
    onEndCounting: PropTypes.func.isRequired,
    isAvatarInitialized: PropTypes.bool.isRequired,
    isExternalURLSourcePresent: PropTypes.bool.isRequired,
    arLanguage: PropTypes.string.isRequired,
    isPaused: PropTypes.bool.isRequired,
};

TRCCountdownView.defaultProps = {
    narrateScreen: () => {},
    cleanup: () => {},
    countdownTitle: null,
};
